import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { QueryParamsProvider } from '@hooks/queryParams/QueryParamsProvider';

import App from './App';
import { store } from './store';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryParamsProvider>
        <App />
      </QueryParamsProvider>
    </Provider>
  </React.StrictMode>,
);
